<div class="w-100">
  <h2 >Experience</h2>

  <div
    class="
      resume-item
      d-flex
      flex-column flex-md-row
      justify-content-between      
    "
  >
    <div class="resume-content">
      <div *ngFor="let experience of experienceList" class="mt-5">
        <div class="resume-date text-md-right" *ngIf="experience.duration">
          <span class="text-primary">{{ experience.duration }}</span>
        </div>
        <h3 class="mb-0" *ngIf="experience.title">{{ experience.title }}</h3>
        <div class="subheading mb-2" *ngIf="experience.company">
          {{ experience.company }}
        </div>
        <div class="subheading mb-2" *ngIf="experience.domain">
          Domain: {{ experience.domain }}
        </div>
        <div class="subheading mb-2" *ngIf="experience.description">
          Description
        </div>
        <p>{{ experience.description }}</p>
        <div class="subheading mb-2" *ngIf="experience.responsibilities">
          Responsibilities
        </div>
        <ul>
          <li *ngFor="let responsibilty of experience.responsibilities">
            {{ responsibilty }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
